import { Box, Flex, IconButton, Text, useBreakpointValue } from '@chakra-ui/react';
import { BaseButton, useAuth } from '@invara-dev/react-base';
import { LuDownload, LuShare, LuX } from 'react-icons/lu';
import { useInstallPrompt } from '../../hooks/useInstallPrompt';

export const InstallAppBanner = () => {
  const { canInstall, isIOS, showBanner, promptInstall, dismissInstall } = useInstallPrompt();
  const { isAuthenticated } = useAuth();
  const isMobile = useBreakpointValue({ base: true, lg: false });

  if (!isAuthenticated || !showBanner || !isMobile) return null;

  return (
    <Box
      position='fixed'
      bottom='0'
      left='0'
      right='0'
      bg='white'
      borderTopWidth='1px'
      borderColor='gray.200'
      px={4}
      py={3}
      zIndex='banner'
      shadow='0 -2px 10px rgba(0,0,0,0.1)'>
      <Flex alignItems='center' gap={3}>
        <Box flex='1'>
          {canInstall && (
            <>
              <Text fontWeight='bold' fontSize='sm'>
                Install MopSpot
              </Text>
              <Text fontSize='xs' color='gray.600'>
                Add to your home screen for quick access
              </Text>
            </>
          )}
          {isIOS && !canInstall && (
            <>
              <Text fontWeight='bold' fontSize='sm'>
                Install MopSpot
              </Text>
              <Text fontSize='xs' color='gray.600'>
                Tap <LuShare style={{ display: 'inline', verticalAlign: 'middle' }} /> then "Add to Home Screen"
              </Text>
            </>
          )}
        </Box>

        {canInstall && (
          <BaseButton size='sm' onClick={promptInstall}>
            <LuDownload />
            Install
          </BaseButton>
        )}

        <IconButton aria-label='Dismiss' variant='ghost' size='sm' onClick={dismissInstall}>
          <LuX />
        </IconButton>
      </Flex>
    </Box>
  );
};
